import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageCollonges: React.FC = () => (
  <LocalSeoPage
    city="Collonges-sous-Salève"
    cityShort="Collonges"
    slug="depannage-informatique-collonges-sous-saleve"
    metaTitle="Dépannage Informatique Collonges-sous-Salève | SOS IT"
    metaDescription="Technicien informatique à Collonges-sous-Salève. PC lent, virus, WiFi. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur ne fonctionne plus à Collonges-sous-Salève ? Notre technicien intervient rapidement, à domicile ou à distance. PC lent, virus, problème WiFi ou Windows bloqué — on s'en occupe avec un diagnostic gratuit et un devis clair."
    postalCode="74160"
    nearbyTowns={[
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Archamps', link: '/depannage-informatique-archamps' },
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Neydens' },
      { name: 'Beaumont' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Archamps', href: '/depannage-informatique-archamps' },
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Dépannage informatique dans la région de Genève', href: '/depannage-informatique-region-geneve' },
    ]}
  />
);

export default DepannageCollonges;
